module.exports = __webpack_public_path__ + "img/1-(1).5ef5edbc.jpg";